"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tab: function() {
        return _Tab.Tab;
    },
    TabList: function() {
        return _TabList.TabList;
    },
    TabListProvider: function() {
        return _TabList.TabListProvider;
    },
    renderTabList_unstable: function() {
        return _TabList.renderTabList_unstable;
    },
    renderTab_unstable: function() {
        return _Tab.renderTab_unstable;
    },
    tabClassNames: function() {
        return _Tab.tabClassNames;
    },
    tabListClassNames: function() {
        return _TabList.tabListClassNames;
    },
    tabReservedSpaceClassNames: function() {
        return _Tab.tabReservedSpaceClassNames;
    },
    useTabAnimatedIndicatorStyles_unstable: function() {
        return _Tab.useTabAnimatedIndicatorStyles_unstable;
    },
    useTabButtonStyles_unstable: function() {
        return _Tab.useTabButtonStyles_unstable;
    },
    useTabContentStyles_unstable: function() {
        return _Tab.useTabContentStyles_unstable;
    },
    useTabIndicatorStyles_unstable: function() {
        return _Tab.useTabIndicatorStyles_unstable;
    },
    useTabListContextValues_unstable: function() {
        return _TabList.useTabListContextValues_unstable;
    },
    useTabListContext_unstable: function() {
        return _TabList.useTabListContext_unstable;
    },
    useTabListStyles_unstable: function() {
        return _TabList.useTabListStyles_unstable;
    },
    useTabList_unstable: function() {
        return _TabList.useTabList_unstable;
    },
    useTabStyles_unstable: function() {
        return _Tab.useTabStyles_unstable;
    },
    useTab_unstable: function() {
        return _Tab.useTab_unstable;
    }
});
const _Tab = require("./Tab");
const _TabList = require("./TabList");
 // Experimental APIs - will be uncommented in experimental release
 // export type { TabBaseProps, TabBaseState } from './Tab';
 // export { useTabBase_unstable, useTabA11yBehavior_unstable } from './Tab';
 // export type { TabListBaseProps, TabListBaseState } from './TabList';
 // export { useTabListBase_unstable, useTabListA11yBehavior_unstable } from './TabList';
